var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "3rem",
    width: "3rem",
    stroke: "white",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5.400000095367432 0.30000001192092896 13.100000381469727 23.400001525878906",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.8 23.7-1.4-1.4L15.7 12 5.4 1.7 6.8.3 18.5 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSlide);
export default __webpack_public_path__ + "static/media/nextSlide.9a49c780ce9c9851caabd6efc9bea0b5.svg";
export { ForwardRef as ReactComponent };